import styled from 'styled-components/macro';

export const StyledMapWrapper = styled.div`
  position: relative;

  .leaflet-control-zoom {
    top: calc(50vh - 60px);
  }
`;
